
import React from 'react';
// 404 Error pages PAGE NOT FOUND
export const Error404 = () => {
    return (
        <div className="u_error-page u_error-page-404">
            <div className="u_error-page-desc u_mb-30">
                <img src="/images/error_404.svg" alt="OOPS! PAGE NOT FOUND" />
                <h2>OOPS! PAGE NOT FOUND</h2>
            </div>
        </div>
    );
}